import { VOMedia, VOMediaType } from "../model/DataStructure.js";
import { Icon } from "./Icon.js";
import { MediaContent, MediaContentOptions } from "./MediaContent.js";
import { PageIndicator } from "./PageIndicator.js";

export interface MediaGalleryOptions extends MediaContentOptions {

}

export class MediaGallery extends MediaContent<MediaGalleryOptions>{

    public readonly type: VOMediaType = "gallery";

    private _content: HTMLDivElement;
    private _galleryIndex: number = 0;
    private _pageIndicator: PageIndicator;
    private _image: HTMLImageElement;
    private _data: VOMedia;

    constructor(options: MediaGalleryOptions) {
        super(options);

        this._element.classList.add("media-gallery");

        this._content = document.createElement("div");
        this._content.className = "media-content__content media-gallery__content";
        this._content.innerHTML = `
            <img class="media-gallery__image media-gallery__image--hidden"></img>
            <div class="media-gallery__control media-gallery__control--prev ${Icon.CHEVRON_LEFT}" data-action="gallery-prev"></div>
            <div class="media-gallery__control media-gallery__control--next ${Icon.CHEVRON_RIGHT}" data-action="gallery-next"></div>
        `;
        this._body.appendChild(this._content);

        this._image = this._content.querySelector(".media-gallery__image");

        this._image.addEventListener("load", () => {
            this._image.classList.remove("media-gallery__image--hidden");
        });

        this._pageIndicator = new PageIndicator({
            container: this._control,
            onSelect: (index: number) => {
                this.loadGalleryIndex(index)
            }
        });

        e5.event.on({
            type: "click",
            scope: this._element,
            selector: `[data-action="gallery-prev"]`,
            listener: (e) => {
                this.loadGalleryIndex(this._galleryIndex - 1);
            }
        });

        e5.event.on({
            type: "click",
            scope: this._element,
            selector: `[data-action="gallery-next"]`,
            listener: (e) => {
                this.loadGalleryIndex(this._galleryIndex + 1);
            }
        });

        this.onHide.add(() => {
            this._image.classList.add("media-gallery__image--hidden");
        });
    }

    public load(data: VOMedia): void {
        this.onLoad.dispatch();
        this.onReady.dispatch();
        this.caption = "";
        this._data = data;
        this.loadGalleryIndex(0);
    }

    private _timeout: any = null;

    private loadGalleryIndex(index: number): void {
        clearTimeout(this._timeout);

        let length = this._data?.gallery?.length || 0;
        this._galleryIndex = e5.Calc.wrap(index, length);

        let showPrev = length > 1;
        this._element.querySelectorAll(`[data-action="gallery-prev"]`)
            .forEach((e) => {
                e.classList.toggle("e5-hidden", !showPrev);
            });

        let showNext = length > 1;
        this._element.querySelectorAll(`[data-action="gallery-next"]`)
            .forEach((e) => {
                e.classList.toggle("e5-hidden", !showNext);
            });

        this._pageIndicator.update(this._galleryIndex, length);
        this._pageIndicator.visible = length > 1;

        this._image.classList.add("media-gallery__image--hidden");

        this._timeout = setTimeout(() => {

            let item = this._data?.gallery[this._galleryIndex];
            let caption = "";
            if (item.image) {
                this._image.style.aspectRatio = `${item.image.width} / ${item.image.height}`;
                this._image.setAttribute("data-layout", this.getLayout(item.image.width / item.image.height));

                this._image.src = item.image.url;

                caption = item.caption || this._data.caption || "";

            } else {
                this._image.src = "";
                caption = this._data.caption || "";
            }
            this.caption = caption;

        }, 300);
    }
}